// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-blue-950 text-white py-6 px-4 mt-10">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center text-sm space-y-4 md:space-y-0">
        <div>
          &copy; {new Date().getFullYear()} OP Game Tracker. All rights reserved.
        </div>
        <div className="flex space-x-6">
          <Link to="/PrivacyPolicy" className="hover:underline">Privacy Policy</Link>
          <Link to="/TermsofUse" className="hover:underline">Terms of Use</Link>
          <Link to="/contact" className="hover:underline">Contact</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
